import React from "react";
import { Field as FormikField, ErrorMessage } from "formik";
import styled from "styled-components/macro";
import * as R from "ramda";

import Message from "./ErrorMessage";
import Label from "./Label";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;

const HelpMessage = styled.div`
  color: rgba(0, 0, 0, 0.45);
  line-height: 2;
  font-size: 14px;
`;

const RequiredMark = styled.span`
  color: #f5222d;
  margin-right: 4px;
  font-size: 10px;
`;

const Field = ({
  label,
  name,
  children,
  validate,
  getValueFromEvent,
  showRequiredMark = false,
  showError = true,
  help,
  onChange = () => {},
  containerProps,
  valueProp = "value",
  ...props
}) => (
  <Container {...containerProps}>
    {label && (
      <Label>
        {showRequiredMark && <RequiredMark>*</RequiredMark>}
        {label}
      </Label>
    )}
    <FormikField name={name} validate={validate} {...props}>
      {({ field, form }) =>
        React.cloneElement(
          children,
          R.mergeAll([
            props,
            field,
            {
              [valueProp]: field.value,
              onBlur: () => form.setFieldTouched(name, true),
              onChange: event => {
                const value = getValueFromEvent
                  ? getValueFromEvent(event)
                  : R.prop("target", event)
                    ? R.path(["target", "value"], event)
                    : event;

                onChange(value);
                form.setFieldValue(name, value);
              }
            }
          ])
        )
      }
    </FormikField>
    {showError && <ErrorMessage component={Message} name={name} />}
    {help && <HelpMessage>{help}</HelpMessage>}
  </Container>
);

export default Field;
